export default __webpack_public_path__ + "static/media/DinosaurSafari_06.e68a6808.png";